import { render, staticRenderFns } from "./CardPie.vue?vue&type=template&id=bddba20e&"
import script from "./CardPie.vue?vue&type=script&lang=js&"
export * from "./CardPie.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports